const FUEL_TYPES = {
  a55: $localize`A55`,
  biodiesel: $localize`Biodiesel`,
  cng: $localize`Compressed natural gas`,
  diesel: $localize`Diesel`,
  e85: $localize`E-85`,
  electric: $localize`Electric`,
  ethanol: $localize`Ethanol`,
  gasoline: $localize`Gasoline`,
  hydrogen: $localize`Hydrogen`,
  hybrid_electric: $localize`Hybrid electric`,
  lng: $localize`Liquid natural gas`,
  m85: $localize`M-85`,
  methanol: $localize`Methanol`,
  plug_in_hybrid_electric: $localize`Plug-in hybrid electric`,
  propane: $localize`Propane`,
  other: $localize`Other`,
};

export enum VEHICLE_FUEL_TYPES {
  DIELSEL = 'diesel',
  GASOLINE = 'gasoline',
  PROPANE = 'propane',
  LNG = 'lng',
  CNG = 'cng',
  ETHANOL = 'ethanol',
  METHANOL = 'methanol',
  E85 = 'e85',
  M85 = 'm85',
  A55 = 'a55',
  BIODIESEL = 'biodiesel',
  ELECTRIC = 'electric',
  OTHER = 'other',
  HYDROGEN = 'hydrogen',
  HYBRID_ELECTRIC = 'hybrid_electric',
  PLUG_IN_HYBRID_ELECTRIC = 'plug_in_hybrid_electric',
}

export function isChargeableFuelType(fuelType: string): boolean {
  return (
    fuelType === VEHICLE_FUEL_TYPES.ELECTRIC ||
    fuelType === VEHICLE_FUEL_TYPES.HYBRID_ELECTRIC ||
    fuelType === VEHICLE_FUEL_TYPES.PLUG_IN_HYBRID_ELECTRIC
  );
}

export { FUEL_TYPES };
